import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "Uue hinnangu lisamine", -1)
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = {
  key: 0,
  class: "text-danger validation-summary-errors",
  "data-valmsg-summary": "true"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, "Toote nimi", -1)
const _hoisted_7 = { class: "col-8" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, "Triipkood", -1)
const _hoisted_10 = { class: "col-8" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-4 control-label" }, "Hinne", -1)
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-4 control-label" }, "Tekst", -1)
const _hoisted_16 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Vue3StarRatings = _resolveComponent("Vue3StarRatings")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock(_component_Header, {
          key: 0,
          title: "",
          back: "home"
        }))
      : _createCommentVNode("", true),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.errorMsg != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, _toDisplayString(_ctx.errorMsg), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.getProduct().name), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.getProduct().barcode), 1)
        ]),
        (_ctx.getReview().id === undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_Vue3StarRatings, {
                  modelValue: _ctx.score,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.score) = $event)),
                  starSize: "24",
                  starColor: "#ff9800",
                  inactiveColor: "#333333",
                  numberOfStars: 5,
                  step: 1,
                  showControl: false,
                  disableClick: false
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description) = $event)),
                  class: "form-control",
                  rows: "3",
                  style: {"min-width":"100%"}
                }, null, 512), [
                  [_vModelText, _ctx.description]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("input", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitClicked())),
                    type: "submit",
                    value: "Lisa hinnang",
                    class: "btn btn-primary"
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}